import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ChipsModule} from "primeng/chips";
import {PasswordModule} from "primeng/password";
import {ConfigService} from "../../services/config.service";
import {ConfirmationService, MessageService} from "primeng/api";
import {Router} from "@angular/router";
import {RestBackendService} from "../../services/rest-backend.service";
import {GlobalService} from "../../services/global.service";
import {AdminUser} from "../../dto/AdminUser";
import {FormsModule} from "@angular/forms";


@Component({
  selector: 'app-admin-login-page',
  standalone: true,
  imports: [
    ChipsModule,
    PasswordModule,
    FormsModule
  ],
  templateUrl: './admin-login-page.component.html',
  styleUrl: './admin-login-page.component.css'
})
export class AdminLoginPageComponent implements OnInit ,AfterViewInit  {

  userName: string="";
  password: string ="";
  @ViewChild("usrnam") usernameField: ElementRef | undefined;
  @ViewChild("pass") passField: ElementRef | undefined;

  constructor(protected restBack: RestBackendService,
              public route: Router,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              public global: GlobalService,
              protected  config: ConfigService
  )  { }


  ngAfterViewInit(): void {

    setTimeout(() => {
      // setTimeout(() => {
      //   document.body.click();
      // },200)
      // @ts-ignore
      this.usernameField.nativeElement.focus();

    }, 600);
  }
  ngOnInit(): void {
    this.checkLogin();

  }


  login() {
    var observable = this.restBack.doGet("lnd/user/login" +
        "?username=" + this.userName+
        "&password=" + this.password
    );
    observable.subscribe((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.global.setCluster(result["cluster"]);
        var user:AdminUser = result["entity"]["user"];
        if (user != null &&user.id != null && user.id >0) {
          this.global.setUser(user);
          this.route.navigate(['/admin/main-page']);
        }else {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary:$localize`:@@login:login`,
            detail:$localize`:@@Login failed:Login failed`
          });
        }
      }else if(status == 401) {
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary:$localize`:@@login:login`,
          detail:$localize`:@@The username or password is incorrect:The username or password is incorrect`
        });
      }

    });

  }

  checkLogin() {
    // this.global.displayCreateApp = true;
    var observable = this.restBack.doGet("lnd/user/check_login");
    observable.subscribe((result: String) => {
      var status = result["status"];

      if (status == 200) {
        this.route.navigate(['/admin/main-page']);
      } else if (status == 401) {
      } else if (status == 1017) {

      }
    });
  }

}
